// extracted by mini-css-extract-plugin
export var cell = "TableRow-module--cell--35576";
export var center = "TableRow-module--center--b2e27";
export var container = "TableRow-module--container--b593e";
export var set = "TableRow-module--set--2c69e";